var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------

var cu = window.STOREFRONT_CURRENCY;
console.log(cu);
Shopify.money_format = cu+" {{amount}}";
Shopify.formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number / 100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

(function(Wishlist, $) {
    var $wishlistButton = $(".wishlist-btn"),
        $wishlistTile = $(".wishlist-tile-container"),
        $wishlistItemCount = $(".wishlist-item-count"),
        numProductTiles = $wishlistTile.length,
        wishlist = localStorage.getItem("user_wishlist") || [];
    wishlist.length > 0 && (wishlist = JSON.parse(localStorage.getItem("user_wishlist")));
    
    var animateWishlist = function(self) {
            $(self).toggleClass("is-active")
        },
        updateWishlist = function(self) {
            var productHandle = $(self).attr("data-product-handle"),
                isRemove = $(self).hasClass("is-active");
            if (isRemove) {
                var removeIndex = wishlist.indexOf(productHandle);
                wishlist.splice(removeIndex, 1), localStorage.setItem("user_wishlist", JSON.stringify(wishlist))
            } else wishlist.push(productHandle), localStorage.setItem("user_wishlist", JSON.stringify(wishlist))
            console.log(JSON.stringify(wishlist))
        },
        updateWishlistNew = function(self) {
            var productHandle = self;
            wishlist.push(productHandle); 
            localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
            console.log(JSON.stringify(wishlist));
        },
        activateItemsInWishlist = function() {
            $wishlistButton.each(function() {
                var productHandle = $(this).attr("data-product-handle");
                wishlist.indexOf(productHandle) > -1 && $(this).addClass("is-active")
            })
        },
        displayOnlyWishlistItems = function() {
            for (var product_handle = String(wishlist).split(","), i = 0; i < product_handle.length; i++) {
                var productHandle = product_handle[i];
                if(productHandle != "insureship-coverage"){
                $.getJSON("/products/" + productHandle + ".js", function(product) {
                    var title_heading = product.title,
                        title = product.title,
                        url = product.url,
                        handle = product.handle,
                        price = 0,
                        original_price = 0,
                        textPrice = "",
                        tags = product.tags;
                    
                    var SPrice = 0;
                    $(product.variants).each(function(i2, v) {
                        var variant = v;
                        variant && (SPrice = variant.price, variant.compare_at_price > variant.price ? (price = Shopify.formatMoney(variant.price, ""), original_price = Shopify.formatMoney(variant.compare_at_price, ""), textPrice = '<span class="ProductItem__Price Price Price--compareAt Text--subdued">' + original_price + '</span><span class="ProductItem__Price Price Price--highlight Text--subdued">' + price + "</span>") : (price = Shopify.formatMoney(variant.price, ""), textPrice = '<span class="ProductItem__Price Price Price--highlight Text--subdued">' + price + "</span>"))
                    });
                  
                    var images = product.media,
                        image_embed = "";
                    if(images){
                      $(images).each(function(i2, image) {
                          i2 < 1 && (image_embed = '<img class="Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[600,700,800,900,1000,1200]" data-sizes="auto" alt="' + title + '" title="' + title + '" data-media-id="' + image.id + '" sizes="410px" src="' + image.src + '"></div>', image_embed = image_embed.replace(".jpg", "_500x.jpg").replace(".png", "_500x.png").replace(".jpeg", "_500x.jpeg").replace(".webp", "_500x.webp").replace(".gif", "_500x.gif"))
                      });
                    }else{
                      image_embed = '<img class="Image--fadeIn lazyautosizes Image--lazyLoaded" data-widths="[600,700,800,900,1000,1200]" data-sizes="auto" alt="' + title + '" title="' + title + '" data-media-id="/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif" sizes="410px" src="/cdn/shopifycloud/shopify/assets/no-image-2048-5e88c1b20e087fb7bbe9a3771824e743c244f437e4f8ba93bbf7b11b53f7824c.gif"></div>';
                    }
                    
                    
                    // SVG icon for remove button
                    var svgIcon = `<svg width="23" height="19" viewBox="0 0 23 19" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M11.2456 18.0984C10.8621 17.9274 10.4352 17.724 9.9753 17.4884C8.5655 16.7701 7.22461 15.934 5.96821 14.9901C2.4405 12.3181 0.367397 9.23377 0.363285 5.78058C0.359858 2.59186 2.97334 0.015425 6.181 0.0134562C6.93972 0.013421 7.69083 0.158201 8.39044 0.439333C9.09005 0.720465 9.72412 1.13231 10.2556 1.6508L11.2277 2.59875L12.1964 1.64719C12.7261 1.12727 13.3588 0.713774 14.0575 0.430934C14.7561 0.148093 15.5067 0.00158929 16.2652 3.14146e-06C19.4753 -0.00327811 22.0932 2.5643 22.0977 5.75499C22.1028 9.21113 20.0341 12.3044 16.5082 14.9845C15.2555 15.9297 13.9184 16.7674 12.5124 17.4881C12.0532 17.723 11.6276 17.9271 11.2456 18.0984Z" fill="black"/></svg>`;

                    var wishlistBtn = `
                        <span class="nws-wishlist-btn" data-product-handle="${handle}">
                          <a class="action--wishlist tile-actions--btn flex wishlist-btn is-active" href="#" data-product-handle="${handle}">
                            ${svgIcon}
                          </a>
                        </span>
                    `;

                    $(".nws-wishlist-grid").append(`
                      <div class="ProductItem nws-wishlist-grid-item col-md-3">
                        <div class="ProductItem__Wrapper">
                         ${wishlistBtn}
                          <a href="${url}" class="ProductItem__ImageWrapper ProductItem__ImageWrapper--withAlternateImage">
                           
                            <div class="ProductItem__Image">${image_embed} </div>
                          </a>
                          <div class="product-card">
                            <div class="product-body">
                              <div class="ProductItem__Info ProductItem__Info--center prod-content">
                                <a href="${url}">
                                  <h3 class="font-14">${title_heading}</h3>
                                </a>
                                <h3 class="wishlist-price font-14">${textPrice}</h3>
                                <a href="${url}" style="display:none;" class="wishlist-view-prod">View Product</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    `);

                    // Use .on to dynamically bind the click event to the wishlist button
                    $(document).on('click', '.nws-wishlist-btn', function() {
                        var handleV = $(this).attr("data-product-handle");
                        wishlist = $.grep(wishlist, function(value) {
                            return value != handleV;
                        });
                        localStorage.setItem("user_wishlist", JSON.stringify(wishlist));
                        $(this).closest('.nws-wishlist-grid-item').hide();
                        updateWishlistItemCount(); // Update the item count after removing
                    });
                });
              }
            }
            String(wishlist) != "" && (numProductTiles = 1)
        },
        loadWishlist = function() {
            window.location.href.indexOf("pages/wishlist") > -1 && (displayOnlyWishlistItems(), $(".wishlist-loader").fadeOut(2e3, function() {
                $(".wishlist-grid").addClass("is_visible"), $(".wishlist-hero").addClass("is_visible"), console.log(numProductTiles), numProductTiles == 0 ? $(".wishlist-grid--empty-list").addClass("is_visible") : $(".wishlist-grid--empty-list").hide()
            }))
        },
        updateWishlistItemCount = function() {
            wishlist && $wishlistItemCount.text(wishlist.length)
        },
        bindUIActions = function() {
            $wishlistButton.click(function(e) {
                e.preventDefault(), updateWishlist(this), animateWishlist(this)
            })
        };
    Wishlist.init = function() {
        bindUIActions(), activateItemsInWishlist(), loadWishlist(), updateWishlistItemCount()
    }

    var user_wishlist_time = localStorage.getItem("user_wishlist_time");
    $.ajax({
      type: 'GET',
      url: '/cart.json',
      dataType: 'json',
      success: function(data) { 
        var item_count = data.item_count;
        if(item_count > 0){
         if(user_wishlist_time == ''){
            var myDate = new Date(new Date().getTime()+(9*24*60*60*1000)); //9 days
            localStorage.setItem("user_wishlist_time", myDate.getDate());
          }else{
            var myDate = new Date(new Date().getTime());
            var chkDate = myDate.getDate();
            var interval = setInterval(function(){
               if(user_wishlist_time == chkDate){
                  $.each(data.items , function(index, val) { 
                    updateWishlistNew(val.handle);
                  }); 
                  localStorage.setItem("user_wishlist_time", "");
                  clearInterval(interval);
               }
             }, 1000); 
          }
        }
      }
    });
  
})(window.Wishlist = window.Wishlist || {}, jQuery, void 0);